import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobile: true,
  },
  mutations: {
    checkMobile(state) {
      state.mobile = $(window).width() < 992
    },
  },
  actions: {

  }
})
